// extracted by mini-css-extract-plugin
module.exports = {"loader":"ButtonLoader_loader__2ge_I","blink":"ButtonLoader_blink__Cpwaf"};